/* eslint-disable */

// AWS region of the IVS Chat room
export const CHAT_REGION = "us-east-1";

// Backend API (output `ApiURL` of the `bolfit-ivs-chat` stack, without trailing slash)
export const API_URL = "https://gztttdy5ph.execute-api.us-east-1.amazonaws.com/Prod";
